const PAGE_NAME = 'EXPENSES';
const ACCOUNT_PREFERENCES = 'showRouteExpenses';

export default { PAGE_NAME, ACCOUNT_PREFERENCES };
